import configureAppStore from "./configureStore";

const store = configureAppStore();

export default store;
